import { PaymentOptionType, } from '@debbie/common/dist/collectors/index.js';
import React from 'react';
import BankTransfer from './BankTransfer.js';
import FI from './FI.js';
import LinkToOwnPayment from './LinkToOwnPayment.js';
import PaymentPortal from './PaymentPortal.js';
import Swift from './Swift.js';
const PaymentOption = (props) => {
    const { paymentOption, collector, case: singleCase } = props;
    switch (paymentOption.type) {
        case PaymentOptionType.BANKTRANSFER:
            return (React.createElement(BankTransfer, { paymentOption: paymentOption, case: singleCase, collector: collector }));
        case PaymentOptionType.FI:
            return React.createElement(FI, { paymentOption: paymentOption, case: singleCase });
        case PaymentOptionType.SWIFT:
            return React.createElement(Swift, { paymentOption: paymentOption });
        case PaymentOptionType.LINK_TO_OWN_PAYMENT:
            return React.createElement(LinkToOwnPayment, { ...props });
        case PaymentOptionType.REEPAY:
        case PaymentOptionType.FARPAY:
        case PaymentOptionType.MOBILE_PEOPLE:
            return React.createElement(PaymentPortal, { ...props });
    }
};
export default PaymentOption;
//# sourceMappingURL=PaymentOption.js.map